<template>
  <div class="createOrder2">
    <nav-header module="发单"></nav-header>
    <div class="container">
        <img
          v-if="jobType == 1"
          src="@/assets/createOrder/tag-freedomService.png"
          alt
          class="form-tag"
        />
        <img
          v-if="jobType == 6"
          src="@/assets/createOrder/tag-b2bService.png"
          alt=""
          class="form-tag"
        />
        <img
          v-if="jobType == 8"
          src="@/assets/createOrder/tag-selfService.png"
          alt=""
          class="form-tag"
        />
        <div class="step-wrapper">
          <form class="form" v-if="showItems" style="padding-left: 0;padding-right: 0;">
            <div class="form-item">
              <div class="label">工单名称<i class="required" v-if="showItems.IsDisposeNameRequired">*</i></div>
              <div class="input-box">
                <input class="input" v-model.trim="form.JobTitle" maxlength="50" type="text" :placeholder="orderPlaceholder" />
              </div>
            </div>
            <div class="form-item">
              <div class="label">工单地址<i class="required" v-if="showItems.IsDisposeAddressRequired">*</i></div>
              <div class="input-box">
                <input class="input address-input" readonly @click="openMap(1)" type="text" :value="form.FullAddress" placeholder="选择地址">
                <!-- <div  class="input address-input" @click="openMap">{{form.FullAddress}}</div> -->
                <span class="btn-text" @click="usualAddress">常用地址</span>
              </div>
              <div class="input-box">
                <input class="input" v-model="form.Address" type="text" placeholder="门牌号" />
              </div>
            </div>
            <div class="form-item">
              <div class="label">现场联系人<i class="required" v-if="showItems.IsSiteContactsRequired">*</i></div>
              <div class="input-box">
                <input class="input" v-model.trim="form.LinkMan" type="text" placeholder="现场联系人即服务签字验收人，请谨慎填写" />
              </div>
            </div>
            <div class="form-item">
              <div class="label">联系电话<i class="required" v-if="showItems.IsSiteContactPhoneRequired">*</i></div>
              <div class="input-box">
                <input class="input" v-model.trim="form.HandSet" type="text" placeholder="请输入现场联系人电话" />
              </div>
            </div>
            <div class="form-item" style="display: flex;align-items: center;">
              <div class="label">工程师上门<br/>名义<i class="required" v-if="showItems.IsDoorNameRequired">*</i></div>
              <div class="input-box">
                <input class="input" v-model.trim="form.EngineerToDoorName" type="text" placeholder="请输入工程师上门名义" />
              </div>
            </div>
            <div class="form-item">
              <div class="label">上门时间<i class="required" v-if="showItems.IsEarliestDoorTimeRequired|| showItems.IsLatestDoorTimeRequired">*</i></div>
              <div class="input-box clear">
                <el-date-picker 
                  type="date" 
                  class="datetime pull-left"
                  v-model="form.ExecStartDate" 
                  placeholder="开始时间" 
                  value-format="yyyy-MM-dd"
                  :picker-options="startOptions"
                  @change="dateAlert"
                ></el-date-picker>
                <i class="line">——</i>
                <el-date-picker 
                  type="date" 
                  :disabled="form.ExecStartDate==''"
                  class="datetime pull-right"
                  v-model="form.ExecEndDate" 
                  placeholder="结束时间" 
                  value-format="yyyy-MM-dd"
                  :picker-options="endOptions"
                ></el-date-picker>
              </div>
            </div>
            <div class="form-item">
              <div class="label">备用联系人<i class="required" v-if="showItems.IsSpareContactsRequired">*</i></div>
              <div class="input-box">
                <input class="input" v-model.trim="form.SecondLinkMan" type="text" placeholder="请输入备用联系人" />
              </div>
            </div>
            <div class="form-item">
              <div class="label">备用联系电话<i class="required" v-if="showItems.IsSpareContactPhoneRequired">*</i></div>
              <div class="input-box">
                <input class="input" v-model.trim="form.SecondHandSet" type="text" placeholder="请输入备用联系方式" />
              </div>
            </div>
            <div class="form-item">
              <div class="label">内部工单号<i class="required" v-if="showItems.IsInnerDisposeCodeRequired">*</i></div>
              <div class="input-box">
                <input class="input" v-model.trim="form.SiemensTicketNumber" type="text" placeholder="请输入内部工单号" />
              </div>
            </div>
            <div class="form-item" v-if="showItems.DisposeType == 1 || jobType == 1">
              <div class="label">预计服务天数<i class="required" v-if="showItems.IsPreServiceDaysRequired">*</i></div>
              <div class="input-box">
                <input class="input" v-model.number="form.ServiceDayCount" type="text" placeholder="请输入预计服务天数" />
                  <span class="unit">天</span>
              </div>
            </div>


            <!-- 标准工单没有预算总价 只有项目/自由存在 -->
            <div class="form-item" v-if="showItems.DisposeType == 2">
              <div class="label">预算总价<i class="required" v-if="showItems.IsLowestBudgetRequired">*</i></div>
              <div class="input-box">
                <div class="pull-left half">
                  <input class="input" type="text" v-model.number="form.MinPrice" placeholder="最低金额" />
                  <span class="unit">元</span>
                </div>
                <i class="line">——</i>
                <div class="pull-right half">
                  <input class="input" type="text"  v-model.number="form.MaxPrice" placeholder="最高金额" />
                  <span class="unit">元</span>
                </div>
              </div>
            </div>
             <template v-for="(item,index) in extraItems">
              <div class="form-item" :key="index">
                <div class="label">
                  {{showItems.ExtendFieldList[index].FieldName }}
                  <i class="required" v-if="showItems.ExtendFieldList[index].IsRequired">*</i>
                </div>
                <div class="input-box">
                  <input class="input" v-model="item.FieldValue" type="text" placeholder />
                </div>
              </div>
            </template>
            <!-- <div class="form-item">
              <span class="label"> </span>
              <label class="checkbox" for="agree">
                <input id="agree" type="checkbox" v-model="form.IsAgree" />
                <i class="icon"></i>
                <span class="checkbox-val">同意</span>
              </label>
              <span class="protocol" @click="showProtocol=true">《工业速派在线技术服务发布规则》</span>
            </div> -->
            <div class="form-item" v-if="jobType==1">
              <div class="label">道具选择</div>
              <div class="props-box">
                <ul>
                  <!-- <li :class="{'on':!form.IsUrgent&&!form.IsTop1&&!form.IsDelay}" @click="form.IsUrgent=false;form.IsTop1=false;form.IsDelay=false;">
                    <h3>不使用道具</h3>
                    <img src="@/assets/createOrder/choosen.png" alt="">
                  </li> -->
                  <li :class="{'on':form.IsPushMsg}" @click="selectProp(5)">
                    <div>
                      <h3>￥{{showItems.PushMsgPropAmount}}</h3>
                      <h3>一键推送</h3>
                      <p>使用后短信通知附近50名工程师</p>
                    </div>
                    <img src="@/assets/createOrder/choosen.png" alt="">
                  </li>
                  <li :class="{'on':form.IsUrgent}" @click="selectProp(1)">
                    <div>
                      <h3>￥{{showItems.UrgentAmount}}</h3>
                      <h3>急单道具</h3>
                      <p>推荐附近10名工程师</p>
                    </div>
                    <img src="@/assets/createOrder/choosen.png" alt="">
                  </li>
                  <li :class="{'on':form.IsTop3}"   @click="selectProp(3)">
                    <div>
                      <h3>￥{{showItems.JobPoolTop3Amount}}</h3>
                      <h3>置顶道具</h3>
                      <p>工单在工单池顶部置顶3天</p>
                    </div>
                    <img src="@/assets/createOrder/choosen.png" alt="">
                  </li>
                  <li :class="{'on':form.IsTop1}"   @click="selectProp(2)">
                    <div>
                      <h3>￥{{showItems.JobPoolTop1Amount}}</h3>
                      <h3>置顶道具</h3>
                      <p>工单在工单池顶部置顶1天</p>
                    </div>
                    <img src="@/assets/createOrder/choosen.png" alt="">
                  </li>
                  <li :class="{'on':form.IsDelay}" @click="selectProp(4)">
                    <div>
                      <h3>￥{{showItems.DelayPastDueAmount}}</h3>
                      <h3>延时道具</h3>
                      <p>工单在工单池展示时间增加3天</p>
                    </div>
                    <img src="@/assets/createOrder/choosen.png" alt="">
                  </li>
                </ul>
              </div>
            </div>


            <!-- <div class="form-item urgent-item" v-if="jobType==1">
              <span class="label">急单服务</span>
              <span class="desc"><i class="tip" @click="showUrgentRule=true">?</i>速派承诺2小时为您的订单推荐工程师，如推荐不成功退回急单费用</span>
              <div class="fr">
                <span class="origin-price">¥{{showItems.UrgentTotalAmount}}</span>
                <span class="current-price">¥{{showItems.UrgentAmount}}</span>
                <label class="checkbox" for="urgent">
                  <input id="urgent" type="checkbox" v-model="form.IsUrgent" />
                  <i class="icon"></i>
                </label>
              </div>
            </div> -->
            <div class="form-item btn-group">
              <div class="btn-default" @click="back">上一步</div>
              <div class="btn-primary" @click="submit">确认发单</div>
            </div>
          </form>
        </div>
    </div>
    <page-footer></page-footer>

    <!-- 选择地址 -->
    <my-dialog title="地址" class="address-dialog" :show="showAddress" @close="showAddress=false">
      <ul class="address-list">
        <li v-for="(item,index) in addressList" :key="index">
          <label class="address-dl">
            <input class="radio" name="address-item" type="radio" v-model="pickedAddress" :value="item"/>
            <div class="address-dt">
              <span class="name">{{item.ContactsName}}</span>
              <span class="phone">{{item.ContactsPhone}}</span>
            </div>
            <div class="address-dd">{{item.FullAddress}}{{item.Address}}</div>
          </label>
          <span class="icon-edit" @click.stop="openEdit(item)">
            <svg class="icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2371"><path d="M896 801.216V864H128v-62.784h768z m-204.288-678.4l155.36 155.36-463.136 463.136-156.864 1.504 1.504-156.864L691.712 122.816z m-0.864 89.632L291.712 611.584l-0.64 67.232 67.2-0.64L757.44 279.04l-66.56-66.56z" fill="#000000" p-id="2372"></path></svg>
          </span>
        </li>
      </ul>
      <div class="btn-group">
        <button class="btn-primary" @click="confirmAddress">确认</button>
        <button class="btn-text"  @click="openEdit()">新增</button>
      </div>
    </my-dialog> 

    <!-- 规则协议 -->
    <my-dialog class="protocol-dialog" title="工控速派在线技术服务发布规则" width="1000px" @close="showProtocol=false" :show="showProtocol">
        <div class="protocol-text">
            <h2></h2>
            <p>工控速派平台，是指工控速派（北京）科技服务有限公司（“工控速派”）旗下运营之工控速派网站（www.insupai.com)、工控速派移动运用软件（APP）以及工控速派微信小程序，旨在为工业自动化、工业智能等相关行业领域的企业、个人提供权威、专业的网络服务平台。无论是否注册的用户在使用本平台时，请您仔细、认真阅读本服务协议内容及其他规则、规范、协议。</p>
            <p>为规范用户快捷有序、权责互明地应用工控速派，确保各方的合法利益，请仔细了解发布规则。</p>
            <h3>一、“工单”定义</h3>
            <p>“工单”是一种非标准化的特定服务产品，对自动化技术服务任务采取了一种更为形象的说法，更易提升用户对自动化技术服务任务的认知，特此定义。具体的解释权归属于工控速派。</p>
            <p>发单方，在工控速派交易平台中，发布“工单”的一方被统称为“发单方”；</p>
            <p>接单方，在工控速派交易平台中，承接“工单”方被统称为“接单方”。</p>
            <h3>二、注册用户具有发“工单”资格</h3>
            <p>为保证“工单”交易的有效性，杜绝虚假信息、恶性交易，保证交易双方的利益，只有通过工控速派审核的注册用户才能进行“工单”交易。</p>
            <p>只要您是工控速派的注册用户，均可直接登录发布信息。如果您还不是工控速派注册用户，请点击免费注册后登录，再进行“工单”的发布。</p>
            <h3>三、发单需遵守如下规则</h3>
            <p>必须是与备品备件、产品维修、维护检修、优化改造、安装调试  品牌售后、维检工具等相关的需求信息，不得发布与此无关的广告、非法信息。否则将被删除，且冻结发“工单”功能；若属非法信息，将会及时通报相关部门并追究法律责任。</p>
            <h4>1、“工单”标题</h4>
            <p>请尽量简洁、清晰的描述您的需求，如“富士P11系列变频器维修”，以便服务方通过标题即可对需求一目了然。</p>
            <h4>2、“工单”分类</h4>
            <p>为让对应的专业服务者准确检索到您的需求信息，请准确勾选与您的需求信息相关的分类，包括：</p>
            <p><b>工作分类：</b>目前可以分为：产品维修、维护检修、优化改造、安装调试、品牌售后等五大类，按照您工作属性来进行划分。</p>
            <p><b>行业分类：</b>请按照您目前工作所在的行业，或者“工单”所在的行业来选择。如果列表中没有体现，请选择“最终用户-其它”，并在描述中说明，便于服务商了解。</p>
            <p><b>产品分类：</b>请依据维修设备或部件选择。</p>
            <p><b>品牌分类：</b>按照实际品牌进行选择，如果列表中没有，请选择“其它”。</p>
            <h4>3、详细描述</h4>
            <p>请详细描述您的服务需求及相关情况，如系统配置、故障描述、工艺要求、应用工况、采购年限等。</p>
            <h4>4、添加附件</h4>
            <p>如果您的需求需要附件辅助说明，如现场照片、图纸、代码等，请在此上传，禁止上传与需求无关的附件，否则冻结发“工单”功能。</p>
            <h3>三、发单范围</h3>
            <p>工控速派可以发布与工业自动化用到的各类产品相关的服务，包括控制类系统，变频、传动，运动控制，过程仪表，执行机构，网络通讯，传感器、周边元件，以及维检工具等等。</p>
            <p>特别注意，有些已经停产的设备、产品，和早期的原装进口生产线（项目、设备），在您周边无法达成维修、维护、升级、改造，通过工控速派，可以减少你找不到维修服务资源带来的困惑。</p>
            <h3>四、“工单”分类</h3>
            <p>在“工单”分类里，通过单选和多选项，快速完成“工单”的发布。在“工单”分类里也提供了便捷的查询功能，可以通过顶部的“查询”功能，输入关键字完成检索，直接找到目标完成筛选。 例如，您可以先选择“品牌分类”，然后在输入框里填写“siemens”，点击“查询”完成筛选。</p>
            <p>如果您发现需要维修的产品，在“工单”分类中的“产品分类”无法找到，请在“产品分类”里填写“其它”，并通过一句话描述来提及“产品名称”、“品牌”和“型号”，让服务商便于识别。</p>
            <p>因需求方造成的信息填写错误导致后续“工单”失败，如发生相关费用，需求方需要承担相应责任。</p>
            <h3>五、关于工控速派的协调职责</h3>
            <p>工控速派本着公平、公证、维护双方权益的职责，对交易双方进行监督、维护、调解等；</p>
            <p>工控速派作为自动化技术服务交易平台的运营方，不参与交易双方的服务实施过程，不涉及双方的权责、义务，也不承担双方交易造成的实际后果。</p>
            <h3>六、以下交易行为不被容许</h3>
            <p>交易价格过于极端，买卖双方达成交易的价格与 “硬件、软件、服务”的实际价值差异过大，例如显失公平、超过或低于市场价格百分之50等类似情况。</p>
            <p>任何违法、非法行为。利用工控速派进行违禁设备的任何行为，此类问题一经查出，将直接移交相关法律部门。工控速派坚决抵制此类行为的发生，不承担任何责任；</p>
            <p>交易任意一方隐瞒真实交易信息，虚假信息，欺诈信息等。</p>
            <h3>七、关于法规遵行</h3>
            <p>用户应遵守国家法律、行政法规、部门规章等规范性文件。对任何涉嫌违反国家法律、行政法规、部门规章的行为，本规则已有规定的，适用本规则；本规则尚无规定的，工控速派有权依据法律法规处理，且工控速派对用户的处理不免除违反方应尽的法律和违约责任。 用户在工控速派上的任何行为，应同时遵守与工控速派规章和协议。</p>
            <p>工控速派有权随时变更本规则并在网站上予以公告。若发单方、接单方不同意相关变更，应立即停止使用工控速派的相关服务或产品。</p>
            <p>工控速派有权对用户行为及应适用的规则进行单方认定，并据此处理。</p>
        </div>
    </my-dialog>

    <!-- 标准单子,自由标准 预付押金弹窗 -->
    <my-dialog class="deposit-dialog" :show="showDeposit" title="预付押金" @close="showDeposit=false;">
      <template v-if="deposit">
        <dl class="module-dl">
          <dt>服务押金：</dt>
          <dd>
            <div class="total">
              总计：
              <span class="price">￥{{deposit.DepositAmount|formatPrice}}</span>
            </div>
          </dd>
        </dl>
       
        <table class="table">
          <tr>
            <th>日期</th>
            <th>时间属性</th>
            <th>工程师数量</th>
            <th>服务价格</th>
          </tr>
          <tr v-for="(item,index) in deposit.Lines " :key="'deposit'+index">
            <td>{{item.Date }}</td>
            <td>{{item.HolidayType | formatDay}}</td>
            <td>{{item.WorkerNum}}</td>
            <td>￥{{item.Money|formatPrice}}</td>
          </tr>
        </table>
        <dl class="module-dl bb">
          <dt>路费押金（{{deposit.WorkDay}}天）：</dt>
          <dd>
            <div class="total">
              总计：
              <span class="price">￥{{deposit.TraficAmount|formatPrice}}</span>
            </div>
            <p class="desc">注释：默认每单每天多收取100元作为路费押金</p>
          </dd>
        </dl> 
        <dl class="module-dl bb">
          <dt>优惠券</dt>
          <dd>
            <span class="disabled" v-if="couponCount==0">暂无可用</span>
            <span class="btn-default" v-if="couponCount!=0 &&  minusCount==0" @click="isShowCoupon=!isShowCoupon">{{couponCount}}张可用</span>
            <span class="price" v-if="couponCount!=0 && minusCount>0" @click="isShowCoupon=!isShowCoupon">-￥{{minusCount|formatPrice}}</span>
            <i class="el-icon el-icon-arrow-down" @click="isShowCoupon=!isShowCoupon"></i>
          </dd>
          <dd class="coupon-wrapper" :style="{height:isShowCoupon?'180px':'0px'}">
            <ul class="list">
              <li v-for="(item,index) in couponList" :key="index" @click="chooseCoupon(index)" :class="{on:index==couponIndex}">
                <div class="dt">
                  <div class="type-name">
                    <div>
                      {{item.CouponTypeStr}}
                      <template v-if="item.CouponType !=3 || (item.CouponType ==1 && item.UseScope!=5)">
                        —{{item.UseScopeStr}}
                      </template>
                    </div>
                    <template v-if="item.CouponType !=3">
                      {{item.UsePermissionStr}}
                    </template>
                  </div>
                  <div class="count" v-if="item.CouponMode ==1">¥{{item.FullReduceOffAmount}}</div>
                  <div class="count" v-if="item.CouponMode ==2">{{item.OffAmount}} <span class="unit">折</span></div>
                  <div class="count" v-if="item.CouponMode ==3">¥{{item.OffAmount}}</div>
                  <div class="desc">{{item.CouponModeStr}}</div>
                  <span class="expire" v-if="item.IsDisplayDateIco">{{item.EffectivityEndTime}}</span>
                </div>
                <div class="dd">
                  <span class="time" >{{item.EffectivityEndTime}}</span>
                  <i class="el-icon el-icon-check"></i>
                </div>
              </li>
            </ul>
          </dd>
        </dl>
        <dl class="module-dl">
          <dt>总押金：</dt>
          <dd>
            <div class="total">
              <span class="price">￥{{deposit.JobTotalAmount-minusCount |formatPrice}}</span>
            </div>
            <!-- <p class="desc">注释：最终根据工单费用来结算如有产生其它费用状况实行多退少补的规则收费</p> -->
          </dd>
        </dl>
           <!-- 道具费用 -->
          <dl class="module-dl" v-if="jobType<=3&&markeyProjectDeposit&&markeyProjectDeposit.JobPropAmount>0">
          <dt>道具费用：</dt>
          <dd>
            <div class="total">
              总计：
              <span class="price" v-if="jobType<=3&&markeyProjectDeposit&&markeyProjectDeposit.JobPropAmount>0">￥{{markeyProjectDeposit.JobPropAmount|formatPrice}}</span>
            </div>
          </dd>
        </dl> 
        <dl class="module-dl" v-if="jobType<=3">
          <dt>总支付费用：</dt>
          <dd>
            <div class="total">
              <span class="price" v-if="jobType<=3&&markeyProjectDeposit">￥{{markeyProjectDeposit.PayTotalAmount-minusCount | formatPrice}}</span>
              <span>（包含6%增值税专用发票）</span>
            </div>
            <p class="desc">备注：标准工单价格只是速派根据市场给出的建议价，最终费用根据实际情况来结算，多退少补，匹配失败不收费，匹配成功后取消需要收取¥15信息和系统使用费。退款即时到账，道具费用不退。</p>
          </dd>
        </dl>
        <div class="btn-group">
          <span class="btn-primary" @click="openPay">确定</span>
        </div>
      </template> 
    </my-dialog>


    <!-- 自由项目预付押金弹窗 -->
    <my-dialog class="deposit-dialog" :show="showMarkeyProjectDeposit" title="预付押金" @close="showMarkeyProjectDeposit=false;">
      <template v-if="markeyProjectDeposit">
        <dl class="module-dl">
          <dt>服务押金：</dt>
          <dd>
            <div class="total">
              总计：
              <span class="price">￥{{markeyProjectDeposit.DepositAmount|formatPrice}}</span>
            </div>
          </dd>
        </dl> 
        <dl class="module-dl bb">
          <dt>优惠券</dt>
          <dd>
            <span class="disabled" v-if="couponCount==0">暂无可用</span>
            <span class="btn-default" v-if="couponCount!=0 &&  minusCount==0" @click="isShowCoupon=!isShowCoupon">{{couponCount}}张可用</span>
            <span class="price" v-if="couponCount!=0 && minusCount>0" @click="isShowCoupon=!isShowCoupon">-￥{{minusCount|formatPrice}}</span>
            <i class="el-icon el-icon-arrow-down" @click="isShowCoupon=!isShowCoupon"></i>
          </dd>
          <dd class="coupon-wrapper" :style="{height:isShowCoupon?'180px':'0px'}">
            <ul class="list">
              <li v-for="(item,index) in couponList" :key="index" @click="chooseCoupon(index)" :class="{on:index==couponIndex}">
                <div class="dt">
                  <div class="type-name">
                    <div>
                      {{item.CouponTypeStr}}
                      <template v-if="item.CouponType !=3 || (item.CouponType ==1 && item.UseScope!=5)">
                        —{{item.UseScopeStr}}
                      </template>
                    </div>
                    <template v-if="item.CouponType !=3">
                      {{item.UsePermissionStr}}
                    </template>
                  </div>
                  <div class="count" v-if="item.CouponMode ==1">¥{{item.FullReduceOffAmount}}</div>
                  <div class="count" v-if="item.CouponMode ==2">{{item.OffAmount}} <span class="unit">折</span></div>
                  <div class="count" v-if="item.CouponMode ==3">¥{{item.OffAmount}}</div>
                  <div class="desc">{{item.CouponModeStr}}</div>
                  <span class="expire" v-if="item.IsDisplayDateIco">{{item.EffectivityEndTime}}</span>
                </div>
                <div class="dd">
                  <span class="time" >{{item.EffectivityEndTime}}</span>
                  <i class="el-icon el-icon-check"></i>
                </div>
              </li>
            </ul>
          </dd>
        </dl>
        <dl class="module-dl">
          <dt>总押金：</dt>
          <dd>
            <div class="total">
              <span class="price">￥{{markeyProjectDeposit.JobTotalAmount-minusCount |formatPrice}}</span>
            </div>
            <!-- <p class="desc">注释：最终根据工单费用来结算如有产生其它费用状况实行多退少补的规则收费</p> -->
          </dd>
        </dl>
        <!-- 道具费用 -->
        <dl class="module-dl" v-if="markeyProjectDeposit.JobPropAmount>0">
          <dt>道具费用：</dt>
          <dd>
            <div class="total">
              总计：
              <span class="price" v-if="markeyProjectDeposit.JobPropAmount>0">￥{{markeyProjectDeposit.JobPropAmount|formatPrice}}</span>
            </div>
          </dd>
        </dl> 
        <dl class="module-dl">
          <dt>总支付费用：</dt>
          <dd>
            <div class="total">
              <span class="price"  v-if="markeyProjectDeposit">￥{{markeyProjectDeposit.PayTotalAmount-minusCount | formatPrice}}</span>
              <span>（包含6%增值税专用发票）</span>
            </div>
            <p class="desc">备注：平台收取项目预算（最低不少于1000元）的30%作为押金，最终费用根据实际情况来结算，多退少补，匹配不成功不收取任何费用，匹配成功后取消需要收取¥15信息和系统使用费。退款即时到账，道具费用不退。</p> 
          </dd>
        </dl>
        <div class="btn-group">
          <span class="btn-primary" @click="openPay">确定</span>
        </div>
      </template>
      
    </my-dialog>

    <!-- 地址列表 -->
    <my-dialog class="form-dialog" :show="showEditAddress" :title="editTitle" @close="showEditAddress=false;" width="600px">
      <address-edit :item="editItem" @success="success" @openMap="openMap"></address-edit>
    </my-dialog>

    <!-- <my-dialog class="protocol-dialog" title="急单规则说明" width="400px" @close="showUrgentRule=false" :show="showUrgentRule">
        <div class="protocol-text">
            <p>1. 服务介绍：适用于自由平台发单需求，开启该模式后即可享受工单加急服务；</p>
            <p>2. 加急服务内容：</p>
            <p>① 发单后2小时内为您匹配工程师;</p>
            <p>②若对接不成功，速派承诺全额退回急单费用；</p>
            <p>3. 服务费用：39.9元；</p>
            <p>4. 生效时间：购买后即生效，仅用于本单使用；每天早8点整至晚8点整（包含周末，但不包含法定节假日）</p>
            <p>5. 最终解释权归工业速派所有</p>
        </div>
    </my-dialog> -->

    <!-- 地图选址 -->
    <my-dialog class="map-dialog" :show="showMap" title="工单地址" @close="showMap=false;">
      <iframe id="map" :src="mapUrl" frameborder="0" class="baidu-map"></iframe>
    </my-dialog>
  </div>
</template>

<script>
import navHeader from "@/components/navHeader.vue";
import footer from "@/components/footer.vue";
import Dialog from "@/components/gkDialog.vue";
import AddressEdit from "@/components/addressEdit.vue";
import { 
  GetAccountJobConfig,
  AddJobBase,
  GetJobDepositDetail,
  GetReplaceSendJob,
  ListJobAddress,
  GetUsableCouponList,
  GetAfterDiscountsAmount,
  CreatePayOrder,
  AddErrorLog,

  GetJobDisposeSet,     //获取最新配置
  AddJobThree,              //提交第三步
} from '@/scripts/api.js'
import valid from '@/scripts/validate.js'
import { FormatTime } from '@/scripts/util.js';
import Bus from '@/scripts/bus.js'
import { mapState } from "vuex";
export default {
  name: "createOrder2",
  components: {
    navHeader,
    "page-footer": footer,
    "my-dialog": Dialog,
    AddressEdit,
  },
  data() {
    return {
      showAddress: false,
      showItems:'',
      defaultTitle:'',
      orderPlaceholder:'',//工单名称placeholder
      form:{
        JobTitle:'',
        Address:'',
        LinkMan:'',
        HandSet:'',
        EngineerToDoorName:'',
        ExecStartDate:'',
        ExecEndDate:'',
        SecondLinkMan:'',
        SecondHandSet:'',
        SiemensTicketNumber:'',
        AddressID:0,
        FullAddress:'',
        CityName:'',
        Lat:'',
        Lng:'',
        MinPrice:'',
        MaxPrice:'',
        EndDate:'',
        ServiceDayCount:'',
        IsUrgent:false,
        IsTop1:false,
        IsTop3:false,
        IsDelay:false,
        IsPushMsg:false
      },
      addressList:[],
      showEditAddress:false,//是否显示地址编辑框
      editTitle:'新增地址',
      editItem:{},//编辑地址信息
      extraItems:[],//额外添加的配置
      pickedAddress:null,//选中的常用地址
      jobType:1,//1:自由工单，6:B2B工单，8内部工单
      showProtocol:false,
      showUrgentRule:false,
      showMap:false,
      showDeposit:false,
      deposit:null,//b2b标准单子或自由标准单子
      showMarkeyProjectDeposit:false,
      markeyProjectDeposit:null,//自由项目单子
      payUrl:'',//支付页面的路径
      isShowCoupon:false,
      couponList:[],
      couponCount:0,
      minusCount:0,//减掉的金额
      pickedCoupon:null,
      couponIndex:null,
      isProject:false,//B2B项目工单？
 
    };
  },
  filters:{
    formatDay(value){
      let day='';
      switch (value) {
        case 1:
          day='工作日';
          break;
        case 2:
          day='周末';
          break;
        case 3:
          day='节假日';
          break;
      }
      return day;
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      publishAgain: (state) => state.publishAgain,
    }),
    //地图地址
    mapUrl(){
      let url=`${location.protocol}//${location.host}${location.pathname}#/baiduMap?userType=${this.userInfo.LoginAccountType}&userId=${this.userInfo.LoginAccountId}`;
      return url;
    },
    // 开始时间禁用设置
    startOptions(){
      var obj={disabledDate:null};
      if(this.form.ExecEndDate){
        obj.disabledDate=(time)=>{
          return time.getTime() > new Date(this.form.ExecEndDate) || time.getTime() < Date.now();
        }
      }else{
        obj.disabledDate=(time)=>{
          return time.getTime() < new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate()).getTime();
        }
      }
      return obj;
    },
    // 结束时间禁用设置
    endOptions(){
      var obj={disabledDate:null};
      if(this.form.ExecStartDate){
        obj.disabledDate=(time)=>{
          return time.getTime() < new Date(this.form.ExecStartDate) - 86400000;
        }
      }else{
        obj.disabledDate=(time)=>{
          return time.getTime() < new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate()).getTime();
        }
      }
      return obj;
    },
    deadlineOptions(){
      var obj={disabledDate:null};
      if(this.form.ExecEndDate){
        obj.disabledDate=(time)=>{
          return time.getTime() > new Date(this.form.ExecEndDate).getTime() || time.getTime() < Date.now() - 60*60*24*1000;
        }
      }else{
        obj.disabledDate=(time)=>{
          return time.getTime() < Date.now();
        }
      }
      return obj;
    },
  },
  watch:{
    'form.ExecStartDate'(value){
      if(!value){
        this.form.ExecStartDate='';
        this.form.ExecEndDate='';
      }
    },
    //根据编辑对象的id显示弹框名
    editItem:{
      handler(value) {
        if(value.ID){
          this.editTitle='编辑地址';
        }else{
          this.editTitle='新增地址';
        }
      },
      deep:true
    },
  },
  created() {
   console.log("created-jobType:"+this.jobType);
  },
  activated() {
    this.jobType = Number(this.$route.query.jobType) || 1;

    console.log("activated-jobType:"+this.jobType);
    this.jobId=Number(this.$route.query.jobId),
    this.defaultTitle=this.$route.query.jobTitle;
    this.orderPlaceholder="请输入工单名称，例如："+this.defaultTitle;
    this.isProject=this.$route.query.isProject;
    this.showDeposit=false;
    this.showMarkeyProjectDeposit=false;

    // console.log('activated-showMarkeyProjectDeposit:'+  this.showMarkeyProjectDeposit)

    this.ServiceOfferIdArray = this.$route.query.ServiceOfferId.split(',')
    this.form.ExecStartDate= this.dateFormat(new Date().setTime(new Date().getTime() + 3600 * 1000 * 24))
    this.form.ExecEndDate= this.dateFormat(new Date().setTime(new Date().getTime() + (3600 * 1000 * 24 * 2)))
    // console.log('activated-publishAgain:'+JSON.stringify(this.publishAgain))
    this.pageInit();
    this.receiveData();
  },
  methods: {
    dateFormat(dateData) {
      var date = new Date(dateData)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      const time = y + '-' + m + '-' + d
      return time
    },
    //页面初始化
    pageInit() {
      //获取页面配置
      let type = "";
      switch (this.jobType) {
        case 6:
          type = 2;
          break;
        case 8:
          type = 3;
          break;
        default:
          type = 1;
          break;
      }
      let data = {}
      data.ServiceOfferIdArray = this.ServiceOfferIdArray
      data.UserCode= this.userInfo.UserCode
      data.JobType= this.jobType
      GetJobDisposeSet(data).then(r=> {
          if (r.Result == 1) {
                var arr=[];
                this.showItems=r.Data; 
                this.jobType = r.Data.JobType;
                console.log("GetJobDisposeSet-jobType:"+this.jobType);
              if(this.showItems && this.showItems.ExtendFieldList && this.showItems.ExtendFieldList.length>0){
                this.showItems.ExtendFieldList.forEach(item => {
                  var obj={};
                  obj['FieldIndex']=item.FieldIndex;
                  obj['FieldValue']='';
                  arr.push(obj);
                });
              }
          this.extraItems=arr;
          // console.log("GetJobDisposeSet- this.showItems:"+JSON.stringify(this.showItems))
          if(this.publishAgain){
            this.createAgain();
          }
        }
      })
      // GetAccountJobConfig({
      //   platform: "pcweb",
      //   platformType: type,
      //   UserCode: this.userInfo.UserCode,
      // }).then((r) => {
      //   if (r.Result == 1) {
      //     this.showItems=r.Data;
      //     //新选项
      //     var arr=[];
      //     if(this.showItems && this.showItems.ExtendFieldList && this.showItems.ExtendFieldList.length>0){
      //       this.showItems.ExtendFieldList.forEach(item => {
      //         var obj={};
      //         obj['FieldId']=item.ID;
      //         obj['FieldValue']='';
      //         arr.push(obj);
      //       });
      //     }
      //     this.extraItems=arr;
      //     this.getAgencyData();
      //     if(this.publishAgain){
      //       this.createAgain();
      //     }
      //   }
      // });
    },
    //再发一单
    createAgain(){
      let step2=this.$store.state.publishAgain.ThreeStep;
      if(step2){ 
        //form对象
        for (let k in step2) {
          if (Object.prototype.hasOwnProperty.call(this.form,k)) {

            // console.log("createAgain-k:"+k+";step2[k]:"+step2[k]);
            this.form[k]=step2[k];
          }
          else{
            // console.log("createAgain-k:"+k+";没有该字段");
          }
        } 
        // console.log("createAgain-showDeposit:"+this.showDeposit);
        // console.log("createAgain-showMarkeyProjectDeposit:"+this.showMarkeyProjectDeposit);
        
        // console.log("createAgain-IsUrgent:"+this.form.IsUrgent);
        // console.log("createAgain-IsTop1:"+this.form.IsTop1);
        // console.log("createAgain-IsDelay:"+this.form.IsDelay);

        this.form.MinPrice=Number(step2.MinPrice)?Number(step2.MinPrice):'';
        this.form.MaxPrice=Number(step2.MaxPrice)?Number(step2.MaxPrice):'';
        this.form.ExecStartDate= this.dateFormat(new Date().setTime(new Date().getTime() + 3600 * 1000 * 24))
        this.form.ExecEndDate= this.dateFormat(new Date().setTime(new Date().getTime() + (3600 * 1000 * 24 * 2)))
        this.form.ServiceDayCount=step2.ServiceDayCount?step2.ServiceDayCount:'';
        // this.extraItems=step2.ExtendValueList || [];
        for (let i = 0; i < step2.ExtendValueList.length; i++) {
          for (let j = 0; j < this.extraItems.length; j++) {
            if(this.extraItems[j].FieldIndex==step2.ExtendValueList[i].FieldIndex){
              this.extraItems[j].FieldValue=step2.ExtendValueList[i].FieldValue;
            }
          }
        }
      }
    },
    //获取代发工单信息
    getAgencyData(){
      GetReplaceSendJob({
        UserCode:this.userInfo.UserCode,
        JobType:this.jobType,
        platform:'pcweb'
      }).then(r=>{
        if(r.Result==1 && r.Data.ReplaceSendJobId){
          this.agencyId=r.Data.ReplaceSendJobId;
          let step2=r.Data.SecondStep;
          //form对象
          for (let k in step2) {
            if (Object.prototype.hasOwnProperty.call(this.form,k)) {
              this.form[k]=step2[k];
            }
          }
          this.form.MinPrice=Number(step2.MinPrice)?Number(step2.MinPrice):'';
          this.form.MaxPrice=Number(step2.MaxPrice)?Number(step2.MaxPrice):'';
          this.form.ServiceDayCount=step2.ServiceDayCount?step2.ServiceDayCount:'';
          // this.extraItems=step2.ExtendValueList || [];
          
          for (let i = 0; i < step2.ExtendValueList.length; i++) {
            for (let j = 0; j < this.extraItems.length; j++) {
              if(this.extraItems[j].FieldId==step2.ExtendValueList[i].FieldId){
                this.extraItems[j].FieldValue=step2.ExtendValueList[i].FieldValue;
              }
            }
          }
        }
      })
    },
    //接受iframe传出来的信息
    receiveData(){
      let that=this;
      window.addEventListener('message',function(e) {
        let data={};
        let value=e.data;
        if(that.$isJsonString(value)){
          data=JSON.parse(value);
        }
        if(that.showEditAddress){
          Bus.$emit('confirmMap',data);
        }else{
          if(data.Lat){
            // that.pickedAddress={};
            for (let i in data) {
              that.form[i]=data[i];
              // that.pickedAddress[i]=data[i];
            }
          }
        }
        that.showMap=false;
        
      })
    },
    //日历确认提示
    dateAlert(value){
      if(value && FormatTime(new Date(),'yyyy-MM-dd')==value){
        this.$alert('工业速派将为向您服务的工程师购买商业保险，该商业保险系隔日生效，如您于商业保险生效前强行要求施工而给工程师、您及其工作人员或第三方造成人身及财产损失的，由您自行承担全部责任');
      }
    },
    //常用地址
    usualAddress(){
      this.pickedAddress=null;
      var params={
        platform:'pcweb',
      }
      if(this.userInfo && this.userInfo.LoginAccountType==1){
        params['UserId']=this.userInfo.LoginAccountId;
      }else if(this.userInfo && this.userInfo.LoginAccountType==2){
        params['CompanyId']=this.userInfo.LoginAccountId;
      }else{
        return;
      }
      ListJobAddress(params).then(r=>{
        if(r.Result==1){
          var list=r.Data || [];
          for (let i = 0; i < list.length; i++) {
            list[i]['checked']=false;
          }
          this.addressList=list;
          this.showAddress=true;
        }else{
          this.$toast('您没有常用地址，请添加！');
        }
      })
    },
    //确认常用地址
    confirmAddress(){
      if(this.pickedAddress){
        this.form.AddressID=this.pickedAddress.ID;
        this.form.Address=this.pickedAddress.Address;
        this.form.LinkMan=this.pickedAddress.ContactsName;
        this.form.HandSet=this.pickedAddress.ContactsPhone;
        this.form.CityName=this.pickedAddress.CityName;
        this.form.FullAddress=this.pickedAddress.FullAddress;
        this.form.Lat=this.pickedAddress.Lat;
        this.form.Lng=this.pickedAddress.Lng;
        this.showAddress=false;
      }else{
        this.$toast('请选择地址！');
      }
    },
    //打开编辑地址弹框
    openEdit(item){
      if(item){
        this.editItem=item;
      }else{
        this.editItem={};
      }
      this.showEditAddress=true;
    },
    //打开地图
    openMap(data){
      
      if(data && typeof data =='object'){
        this.pickedAddress=data;
      }else if(data==1 && this.form.FullAddress){
        this.pickedAddress={
          FullAddress:this.form.FullAddress,
          Lat:this.form.Lat,
          Lng:this.form.Lng,
          CityName:this.form.CityName,
        };
      }else {
        this.pickedAddress={
          FullAddress:'',
          Lng: '116.40',
          Lat: '39.92',
          CityName: '北京市',
        };
      }
      this.showMap=true;
      this.$nextTick(()=>{
        if(this.pickedAddress){
          document.getElementById('map').contentWindow.postMessage(JSON.stringify(this.pickedAddress),'*');
        }
      })
    },
    //添加/编辑成功
    success(){
      this.showEditAddress=false;
      this.usualAddress();
    },
    //获取押金明细
    getDeposit(){
      var jobType=this.jobType;
      var isProject=this.isProject;
      GetJobDepositDetail({
        JobId:this.jobId,
        platform:'pcweb',
      }).then(r=>{
        if(r.Result==1){
          if(jobType==6)
          {
            this.deposit=r.Data.B2BStandardJobDeposit;
            this.showDeposit=true;
          }
          else if(jobType<=3)
          {
            if(!isProject)
            {
              this.deposit=r.Data.MarketJobDeposit.StandardJobDeposit;
              this.markeyProjectDeposit=r.Data.MarketJobDeposit;
              this.showDeposit=true;
            } 
            else  
            {
              this.markeyProjectDeposit=r.Data.MarketJobDeposit;
              this.showMarkeyProjectDeposit=true;
            }
          }
          this.couponIndex=null;
          this.minusCount=0;
        }
        else{
          this.$toast(r.Message);
        }
      })
      this.getCouponList();
    },
    //获取用户可用优惠券
    getCouponList(){
        let params={
            UserCode:this.userInfo.UserCode, 
            JobId:this.jobId,
            PageNum:1,
            PageSize:999,
            WhoUseTypes:24,
            platform:'pcweb',
        }
        GetUsableCouponList(params).then(r=>{
            if(r.Result==1){
                this.couponList=r.Data?.UsableCouponList || [];
                this.couponCount=r.Data?.UsableCouponCounts || 0;
            }else{
                this.$toast(r.Message);
            }
        })
    },
    //选择优惠券
    chooseCoupon(index){
      this.couponIndex=index;
      GetAfterDiscountsAmount({
          JobId:this.jobId,
          PayBusinessType:1,
          CouponId :this.couponList[this.couponIndex].Id,
          ApplyOrderId:0,
          platform:'pcweb',
      }).then(r=>{
          if(r.Result==1){
              this.minusCount=r.Data.OffAmount;
          }else{
              this.$toast(r.Message);
          }
      })
    },
    //发单
    submit() {
      let items={...this.showItems};
      let form={...this.form};
      if(items.IsDisposeNameRequired && form.JobTitle == '') {
        form.JobTitle=this.defaultTitle;
      }
      if(items.IsDisposeAddressRequired && (form.CityID==0 || form.lat==='' || form.Lng==='' || form.FullAddress=='')){
        this.$toast('请选择工单地址');
        return;
      }
      if(items.IsSiteContactsRequired && form.LinkMan==''){
        this.$toast('请输入现场联系人');
        return;
      }
      if(items.IsSiteContactPhoneRequired && form.HandSet==''){
        this.$toast('请输入联系人电话');
        return;
      }
      if(items.IsSiteContactPhoneRequired && (!valid.link(form.HandSet) && form.HandSet!='')){
        this.$toast('联系电话格式不正确');
        return;
      }
      if(items.IsDoorNameRequired && form.EngineerToDoorName==''){
        this.$toast('请输入工程师上门名义');
        return;
      }

      if(items.IsEarliestDoorTimeRequired && form.ExecStartDate==''){
        this.$toast('请选择上门开始时间');
        return;
      }
      if(items.IsLatestDoorTimeRequired && form.ExecEndDate==''){
        this.$toast('请选择上门结束时间');
        return;
      }
      if(items.IsSpareContactsRequired && form.SecondLinkMan==''){
        this.$toast('请输入备用联系人');
        return;
      }
      if(items.IsSpareContactPhoneRequired && form.SecondHandSet==''){
        this.$toast('请输入备用联系人电话');
        return;
      }
      if(items.IsSpareContactPhoneRequired && (!valid.link(form.SecondHandSet) && form.SecondHandSet!='')){
        this.$toast('备用联系人电话格式不正确');
        return;
      }
      if(items.IsInnerDisposeCodeRequired && form.SiemensTicketNumber==''){
        this.$toast('请输入内部工单号');
        return;
      }
      if(items.DisposeType==1 && items.IsPreServiceDaysRequired && form.ServiceDayCount ==''){
        this.$toast('请输入预计服务天数');
        return;
      }
      if(items.DisposeType==1 && items.IsPreServiceDaysRequired && !valid.positiveInt(form.ServiceDayCount)){
        this.$toast('预计服务天数必须是正整数');
        return;
      }
      if(items.DisposeType==2 && items.IsLowestBudgetRequired && (form.MinPrice=='' || form.MaxPrice=='')){
        this.$toast('请输入预算总价');
        return;
      }
      if(items.DisposeType==2 && items.IsLowestBudgetRequired &&(parseFloat(form.MinPrice)>9999999||parseFloat(form.MaxPrice)>9999999)){
        this.$toast('预算总价不能高于9999999');
        return;
      }
      if(items.DisposeType==2 && items.IsLowestBudgetRequired &&(!valid.positiveInt(Number(form.MinPrice)) || !valid.positiveInt(Number(form.MaxPrice)))){
        this.$toast('预算总价为正整数！');
        return;
      }
      
      console.log("submit-extraItems:"+JSON.stringify(this.extraItems))
      console.log("submit-items.ExtendFieldList:"+JSON.stringify(items.ExtendFieldList))
      for (let i = 0; i < items.ExtendFieldList.length; i++) {
        if(items.ExtendFieldList[i].IsRequired && this.extraItems[i].FieldValue==''){
          this.$toast('请输入'+items.ExtendFieldList[i].FieldName);
          return;
        }
      }
      if(items.IsEnterpriseRequired && form.BelongUserName ==''){
        this.$toast('请选择所属企业');
        return;
      }
      let params={
        ...form,
        JobId:this.jobId,
        platform:'pcweb',
        CityID:0,
        ProvinceID:0,
        IsAgree:1,
        ExtendValueList:this.extraItems,
        UserCode: this.userInfo.UserCode
      }
      if(params.MinPrice == '') {
        params.MinPrice = 0
      }
      if(params.MaxPrice == '') {
        params.MaxPrice = 0
      }

      var jobType=this.jobType ;
      AddJobThree(params).then(res=> {
        if(res.Result != 1) {
          return this.$toast(res.Message)
        }
        var data = res.Data;
        console.log("jobType:"+jobType+";IsProjectJob:"+data.IsProjectJob);
        if((jobType==6&&!data.IsProjectJob)||jobType<=3) {
           this.getDeposit() 
        }
        else {
          this.$router.push({
            path:'/createOrderProcess',
            query:{
              jobNo:data.JobNo
            }
          })
          this.form = {
            JobTitle:'',
            Address:'',
            LinkMan:'',
            HandSet:'',
            EngineerToDoorName:'',
            ExecStartDate: '',
            ExecEndDate: '',
            SecondLinkMan:'',
            SecondHandSet:'',
            SiemensTicketNumber:'',
            AddressID:0,
            FullAddress:'',
            CityName:'',
            Lat:'',
            Lng:'',
            MinPrice:'',
            MaxPrice:'',
            EndDate:'',
            ServiceDayCount:'',

            IsUrgent:false,
            IsTop1:false,
            IsTop3:false,
            IsDelay:false,
            IsPushMsg:false
          }
        }
      }).catch((err)=>{
        AddErrorLog('/AddJobBase',err.toString(),params);
      }) 
    },
    //去支付
    openPay(){
      let couponId=0;
      if(this.couponIndex!==null && this.couponList[this.couponIndex]){
        couponId=this.couponList[this.couponIndex].Id;
      }
      let params={
        OuterOrderType:1,
        OuterOrderId:this.jobId,
        TradeType:1,//1：B2B平台，自由单子支付押金，2：自由平台选标，3：追加押金
        UserCouponId:couponId,//优惠券id
        platform:'pcweb'
      }
      CreatePayOrder(params).then(r=>{
        this.showDeposit=false;
        if(r.Result==1){
            this.$router.push({
              path:'/payment',
              query:{
                payId:r.Data.PayId,
                from:1
              }
            })
            this.form = {
              JobTitle:'',
              Address:'',
              LinkMan:'',
              HandSet:'',
              EngineerToDoorName:'',
              ExecStartDate: '',
              ExecEndDate: '',
              SecondLinkMan:'',
              SecondHandSet:'',
              SiemensTicketNumber:'',
              AddressID:0,
              FullAddress:'',
              CityName:'',
              Lat:'',
              Lng:'',
              MinPrice:'',
              MaxPrice:'',
              EndDate:'',
              ServiceDayCount:'',
              IsUrgent:false,
              IsTop1:false,
              IsTop3:false,
              IsDelay:false,
              IsPushMsg:false
            }
        }else{
            this.$toast(r.Message);
        }
      })
    },
    back(){
      this.$router.go(-1);
    },
    selectProp(tt){ 
      if(tt==1){
        this.form.IsUrgent=!this.form.IsUrgent;
      }
      else if(tt==2){
        this.form.IsTop1=!this.form.IsTop1;
      }
      else if(tt==3){
        this.form.IsTop3=!this.form.IsTop3;
      } 
      else if(tt==4){
        this.form.IsDelay=!this.form.IsDelay;
      }
      else if(tt==5){
        this.form.IsPushMsg=!this.form.IsPushMsg;
      }
      console.log(this.form)
    },
  },
};
</script>

<style lang="scss">
.createOrder2 {
  background-color: #f9f9f9;
  min-height: 100vh;
  padding-top: 68px;
  overflow: hidden;
  .header-main {
    width: 1000px;
  }
  .container {
    width: 1000px;
    margin: 40px auto;
    background-color: #fff;
    border-top: 3px solid #f75959;
    position: relative;
    min-height: 80vh;
    .form-tag {
      position: absolute;
      right: -6px;
      top: -6px;
      z-index: 2;
      width: 137px;
      height: 137px;
    }
  }
  .step-wrapper {
    .form {
      width: 700px;
      margin: 20px auto 0;
      padding-bottom: 70px;
    }
    .form-item {
      position: relative;
      margin-bottom: 20px;
      overflow: hidden;
    }
    .input-box {
      min-height: 40px;
      position: relative;
      overflow: hidden;
      width: 600px;
      float: right;
    }
    .label {
      font-size: 14px;
      line-height: 20px;
      font-weight: bold;
      padding: 10px 0;
      color: #333;
      width: 100px;
      float: left;
      padding-right: 8px;
    }
    .input {
      width: 100%;
      height: 40px;
      border: 1px solid #e3e3e3;
      font-size: 14px;
      color: #333;
      padding: 8px 10px;
      line-height: 22px;
    }
    .textarea {
      resize: none;
      width: 100%;
      height: 80px;
      border: 1px solid #e3e3e3;
      font-size: 14px;
      color: #333;
      line-height: 22px;
      padding: 8px 10px;
    }
    .address-input{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      right: 70px;
    }
    .btn-text {
      font-size: 14px;
      color: #f75959;
      line-height: 40px;
      cursor: pointer;
      position: absolute;
      right: 20px;
      top: 0;
      z-index: 2;
    }
    .el-date-editor {
      display: block;
    }
    .el-date-editor {
      .el-input__inner {
        padding-left: 10px;
        border-radius: 0;
      }
      .el-icon-date {
        display: none;
      }
      .el-input__suffix {
        right: 30px;
      }
      &:after {
        content: "";
        position: absolute;
        right: 0px;
        top: 10px;
        z-index: 2;
        width: 30px;
        height: 20px;
        background: url("~@/assets/createOrder/icon-calendar.png")
          no-repeat right center;
      }
    }
    .datetime {
      width: 270px;
    }
    .deadline {
      width: 100%;
    }
    .half {
      width: 270px;
      position: relative;
    }
    .line {
      color: #999;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
    }
    .el-select .el-input__inner {
      padding-left: 10px;
      border-radius: 0;
    }
    .form-item .remark {
      font-size: 14px;
      color: #999;
      line-height: 24px;
      display: block;
      margin-top: -6px;
    }
    .form-item .unit {
      position: absolute;
      right: 10px;
      top: 0px;
      z-index: 2;
      font-size: 14px;
      color: #999;
      line-height: 40px;
    }
    .form-item .btn-primary,
    .form-item .btn-default  {
      width: 120px;
      height: 40px;
      font-size: 16px;
      line-height: 40px;
    }
    .btn-group{
      text-align: center;
    }
    .btn-default {
      display: inline-block;
      background: #fff;
      border-radius: 2px;
      font-family: inherit;
      color: #f75959;
      text-align: center;
      cursor: pointer;
      border: 1px solid #f75959;
      &+.btn-primary{
        margin-left: 20px;
      }
    }
    .btn-primary {
      display: inline-block;
      background: #f75959;
      border-radius: 2px;
      font-family: inherit;
      color: #fff;
      text-align: center;
      cursor: pointer;
      border: 1px solid #f75959;
    }
    .form-item .remark {
      font-size: 14px;
      color: #999;
      line-height: 24px;
      display: block;
      margin-top: -6px;
    }
    .form-item .unit {
      position: absolute;
      right: 10px;
      top: 0px;
      z-index: 2;
      font-size: 14px;
      color: #999;
      line-height: 40px;
    }
    .sp-select{
      width: 100%;
    }
  .input-box+.input-box{
    margin-top: 12px;
  }
  .urgent-item{
    background-color: #f1f1f1;
    padding-left: 16px;
    padding-right: 16px;
    .label{
      width: auto;
    }
    .desc{
      font-size: 14px;
      color: #999;
      line-height: 40px;
      float: left;
    }
    .tip{
      display: inline-block;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #f75959;
      color: #fff;
      font-size: 12px;
      line-height: 12px;
      text-align: center;
      vertical-align: middle;
      margin-right: 3px;
      margin-top: -3px;
    }
    .fr{
      float: right;
      line-height: 40px;
    }
    .origin-price{
      font-size: 16px;
      color: #F75959;
      text-decoration: line-through;
      vertical-align: middle;
      font-family: "DIN-Regular";
    }
    .current-price{
      font-size: 18px;
      color: #F75959;
      font-weight: bold;
      padding-left: 10px;
      vertical-align: middle;
      font-family: "DIN-Regular";
    }
    .checkbox{
      margin-left: 10px;
      .icon{
        margin-right: 0;
      }
    }
  }
  }
  .address-dialog{
    .address-list {
      max-height: 400px;
      overflow: auto;
      li {
        border-bottom: 1px solid #e5e5e5;
        position: relative;
      }
      .address-dl {
        display: block;
        padding: 10px 0 10px 40px;
        .radio {
          opacity: 0;
          position: absolute;
          left: 0;
          &:checked+.address-dt:before{
            background-color: #f75959;
            border-color:#f75959;
            background-clip: content-box;
          }
        }
      }
      .address-dt {
        margin-bottom: 5px;
        font-size: 16px;
        color: #333;
        line-height: 24px;
        .name {
          margin-right: 20px;
        }
        &:before{
          content:'';
          box-sizing: border-box;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          position: absolute;
          left: 0;
          top: 50%;
          border:1px solid #ddd;
          transform:translateY(-50%);
          background-color: #fff;
          padding: 2px;
        }
      }
      .address-dd{
        font-size: 14px;
        color: #999;
        line-height: 20px;
      }
      .icon-edit{
        position: absolute;
        right: 10px;
        top:10px;
        font-size: 18px;
        color: #666;
        line-height: 1;
        cursor: pointer;
      }
    }

    .btn-group{
      text-align: center;
      margin-top: 30px;
      .btn-primary {
        height: 30px;
        line-height: 30px;
        width: 100px;
        font-size: 14px;
        display: inline-block;
        vertical-align: middle;
      }
      .btn-text{
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
        padding: 0 10px;
        font-size: 14px;
        color: #f75959;
        margin-left: 10px;
        line-height: 30px;
        background-color: transparent;
        &:hover{
          color: #ff3838;
        }
      }
    }
  }
  .baidu-map{
    width: 100%;
    height: 500px;
    .layui-layer-msg {
      display: none !important;
    }
  }
  .protocol-dialog{
    .dialog-title{
      text-align: center;
    }
    .dialog-body{
      height: 500px;
      overflow-y: auto;
    }
    .protocol-text h3 {
      font-size: 14px;
      color: #333;
      margin: 0 0 6px;
      padding-top: 6px;
      text-align: left;
      font-weight: normal;
    }
    .protocol-text h4{
      font-size: 14px;
      color: #666;
      margin: 0 0 6px;
      padding-top: 6px;
      text-align: left;
      font-weight: normal;
    }
    .protocol-text p {
      margin-bottom: 6px;
      text-indent: 2em;
      line-height: 22px;
      font-size: 14px;
      color: #999;
      text-align: left;
    }
  }
  .deposit-dialog{
    .module-dl{
      overflow: hidden;
      padding-top: 15px;
      padding-bottom: 15px;
      &.bb{
        border-bottom: 1px solid #e5e5e5;
      }
      dt{
        float: left;
        font-size: 18px;
        color: #333;
        line-height: 30px;
      }
      dd{
        float: right;
        text-align: right;
        .btn-default{
          display: inline-block;
          width: 70px;
          height: 24px;
          line-height: 22px;
          text-align: center;
          border-radius: 20px;
          font-size: 12px;
          vertical-align: middle;
        }
      }
      .coupon-wrapper{
        overflow: hidden;
        height: 0;
        width: 100%;
        float: left;
        text-align: left;
        transition: height 0.2s linear;
        .list{
          width: 100%;
          height: 180px;
          overflow-y: auto;
          margin-top: 10px;
          >li{
            float: left;
            width: 204px;
            height: 164px;
            margin-right: 15px;
            margin-bottom: 10px;
            background:  url('~@/assets/coupon/bg.png') no-repeat center top;
            background-size: contain;
            border: 2px solid #f75959;
            border-radius: 6px;
            overflow: hidden;
            position: relative;
            &.on{
              border: 2px solid #f75959;
              &:after{
                content: "";
                position: absolute;
                right: -32px;
                bottom: -32px;
                width: 60px;
                height: 60px;
                background-color: #f75959;
                transform: rotate(315deg);
              }
            }
            &:nth-child(3n){
              margin-right: 0;
            }
            .dt{
              height: 120px;
              padding: 5px 6px;
              position: relative;
              padding-top: 40px;
              .type-name{
                font-size: 12px;
                color: #fff;
                line-height: 18px;
                text-align: left;
                position: absolute;
                left: 10px;
                top: 5px;
              }
              .count{
                text-align: center;
                font-size: 48px;
                line-height: 1;
                color: #fff;
                font-weight: bold;
                font-family: "DIN-Regular";
                .unit{
                  font-size: 16px;
                  font-weight: normal;
                }
              }
              .desc{
                text-align: center;
                font-size: 16px;
                color: #fff;
                line-height: 18px;
              }
              .expire{
                position: absolute;
                right: -33px;
                top: -23px;
                font-size: 12px;
                color: #fff;
                line-height: 104px;
                text-align: center;
                width: 80px;
                height: 60px;
                background-color: #00B4FF;
                white-space: nowrap;
                transform: rotate(45deg);
              }
            }
            .dd{
              height: 40px;
              padding:10px 10px;
              .time{
                display: block;
                font-size: 14px;
                line-height: 20px;
                color: #333;
              }
            }
            .el-icon-check{
              position: absolute;
              right: 4px;
              bottom: 4px;
              font-size: 18px;
              color: #fff;
              z-index: 3;
            }
          }
        }
      }
      .disabled{
        line-height: 30px;
        font-size: 12px;
        color: #999;
        vertical-align: middle;
      }
      .el-icon-arrow-down{
        color: #666;
        vertical-align: middle;
        cursor: pointer;
      }
      .total{
        line-height: 30px;
        font-size: 12px;
        color: #999;
      }
      .price{
        font-size: 20px;
        color: #ff3838;
        line-height: 30px;
        font-family: 'DIN-Regular';
      }
      .desc{
        line-height: 24px;
        font-size: 14px;
        color: #666;
        text-align: left;
      }
    }
    .table{
      display: block;
      width: 100%;
      border-bottom: 1px solid #e5e5e5;
      max-height: 200px;
      overflow-y: auto;
      th{
        border-bottom: 1px solid #e5e5e5;
        font-size: 14px;
        color: #999;
        height: 40px;
        line-height: 40px;
        text-align: center;
        width: 165px;
        &:first-child{
          text-align: left;
        }
      }
      td{
        font-size: 14px;
        color: #333;
        height: 32px;
        line-height: 32px;
        text-align: center;
        &:first-child{
          text-align: left;
        }
      }
    }
    .btn-group{
      text-align: center;
    }
    .btn-primary{
      display: inline-block;
      height: 30px;
      line-height: 30px;
      font-size: 14px;
      width: 100px;
      margin-top: 20px;
      text-align: center;
    }
  }
}
.props-box {
  ul {
    display: flex;
    li {
      width: 200px;
      height: 130px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #E3E3E3;
      margin-right: 10px;
      position: relative;
      border-radius: 4px;
      cursor: pointer;
      h3 {
        font-size: 14px;
        color: #333333;
        font-weight: bold;
        line-height: 20px;
      }
      > div {
        text-align: center;
        p {
          font-size: 14px;
          color: #666666;
        }
      }
      img {
        position: absolute;
        right: 0;
        bottom: 0;
        display: none;
      }
    }
    li.on {
      border: 1px solid #f75959;
      img {
        display: block;
      }
    }
  }
}
</style>
